var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-cover"},[_c('img',{staticClass:"header-cover-img",attrs:{"src":_vm.coverUrl}}),_c('img',{staticClass:"header-cover-dim",attrs:{"src":require("../../../public/image/Instrument/157.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }